import { APP_ENVIRONMENT_VALUES } from '@napaicp/shared'
import { z } from 'zod'
import { utcTimestampSchema } from './primitives'

export const healthCheckSchema = z.object({
  name: z.string(),
  ok: z.boolean(),
  detail: z.string().nullable(),
})

export const healthDtoSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  environment: z.enum(APP_ENVIRONMENT_VALUES),
  version: z.string(),
  time: utcTimestampSchema,
  checks: z.array(healthCheckSchema),
  /** Whether the worker has a complete OIDC configuration. Config-derived, not a probe. */
  oidcConfigured: z.boolean(),
})

export type HealthDto = z.infer<typeof healthDtoSchema>
export type HealthCheck = z.infer<typeof healthCheckSchema>
